<template>
	<form>
		<button v-if="download && !file" type="button" @click="dowloadFile" class="btn btn-sm btn-primary">
			Descargar
		</button>
		<p v-if="file instanceof Object">
			{{file.name | str_limit(15)}}
		</p>
		<button type="button" @click="$refs.file.click()" :class="'btn btn-sm btn-' + (download ? 'warning' : 'success')">
			<i class="fas fa-cloud-upload-alt mr-1"></i>
			<span v-if="download || file instanceof Object">Subir nuevamente </span>
			<span v-if="!download && !file ">Cargar archivo</span>
		</button>
		<input hidden ref="file" type="file" @input="onInputChange" :name="name" :id="'certificado-'+this._uid" :accion="accion" :accept="fileExtension">
	</form>
</template>
<script>
import Axios from 'axios';
export default {
	props: [
	'download',
	'accion',
	'name',
	'fileExtension',
	'value'
	],
	data () { return {
		file: null
	}},
	methods: {
		onInputChange (event) {
			if (event.target.files[0]){
				this.file = event.target.files[0];
				this.$emit('input', event.target.files[0]);
			}
		},
		dowloadFile () {
			setTimeout(() => {
				
				axios.get(this.download, {responseType: 'blob'}).then(response => {

					if (response.data instanceof Blob) {
						
						const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = downloadUrl;
						var filename = "";
						const disposition = response.headers['content-disposition'];
						
						if (disposition && disposition.indexOf('attachment') !== -1) {
							
							const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
							const matches = filenameRegex.exec(disposition);

							if (matches != null && matches[1]) {
								
								filename = matches[1].replace(/['"]/g, '');
								link.setAttribute('download', filename)

							}
						}

						document.body.appendChild(link);
						link.click();
						link.remove();

					} else {
						throw { message: 'formatError' }
					}

					toastr["success"]("Descarga lista", "Éxito");

				}).catch(e => {

					toastr["error"]('Ocurrió un problema inesperado', e);
				});
			}, 500);
		}
	},
	watch: {
		value (val) {
			this.file = val
		}
	}
}
</script>
